import { Injectable } from "@angular/core";
import { Storage } from "@ionic/storage";
import { SearchParamsMeeting } from "../user/user";

@Injectable()
export class SearchParamsMeetingProvider {
  private SEARCH_PARAMS_KEY_MEETING: string = "pv-search-params-meeting";
  private _searchParamsMeeting: SearchParamsMeeting;

  constructor(public storage: Storage) {}

  initialParamsMeeting(): SearchParamsMeeting {
    this._searchParamsMeeting = <SearchParamsMeeting>{
      date: new Date().toISOString(),
      age: { min_range: undefined, max_range: undefined },
      meeting_location: [],
      purpose: [],
    };
    return this._searchParamsMeeting;
  }

  async getMeetingParams(): Promise<SearchParamsMeeting> {
    if (this._searchParamsMeeting) return this._searchParamsMeeting;
    this._searchParamsMeeting = await this.storage.get(
      this.SEARCH_PARAMS_KEY_MEETING
    );
    return this._searchParamsMeeting;
  }

  setMeeting(params: SearchParamsMeeting): Promise<any> {
    this._searchParamsMeeting = params;
    return this.storage.set(this.SEARCH_PARAMS_KEY_MEETING, params);
  }

  async setMeetingParam(paramId: string, value: any): Promise<any> {
    const params: SearchParamsMeeting = await this.getMeetingParams();
    params[paramId] = value;
    this._searchParamsMeeting = params;
    return this.setMeeting(params);
  }

  clear(): Promise<any> {
    this._searchParamsMeeting = this.initialParamsMeeting();
    return this.setMeeting(this._searchParamsMeeting);
  }
}



// WEBPACK FOOTER //
// ./src/providers/search-params-meeting/search-params-meeting.ts